import { createWebHistory, createRouter } from "vue-router";
import Home from "@/pages/home-page.vue";
import Question from "@/pages/questions-page.vue";
import NosTarifs from "@/pages/nos-tarifs.vue";
import TwoForm from "@/pages/two-form.vue";
import Page1 from "@/pages/page-1.vue";
import Page2 from "@/pages/page-2.vue";
import Page21 from "@/pages/page-2.1.vue";
import Page22 from "@/pages/page-2.2.vue";
import Page23 from "@/pages/page-2.3.vue";
import Page24 from "@/pages/page-2.4.vue";
import Page25 from "@/pages/page-2.5.vue";
import Page26 from "@/pages/page-2.6.vue";
import Page27 from "@/pages/page-2.7.vue";
import Page28 from "@/pages/page-2.8.vue";
import Page7 from "@/pages/page-7.vue";
import Page4 from "@/pages/page-4.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta:{
      title: "Accueil | Gayssot Recouvrement votre expert gestion du poste clients - Gayssot Recouvrement"
    }
  },
  {
    path: "/faq",
    name: "faq",
    component: Question,
    meta:{
      title: "FAQ | Les bonnes raisons de faire appel à un cabinet de recouvrement | Gayssot Recouvrement"
    }
  },
  {
    path: "/nos-tarifs",
    name: "NosTarifs",
    component: NosTarifs,
    meta:{
      title: "Accueil | Gayssot Recouvrement votre expert gestion du poste clients - Gayssot Recouvrement"
    }
  },
  {
    path: "/audit",
    name: "TwoForm",
    component: TwoForm,
    meta:{
      title: "Accueil | Gayssot Recouvrement votre expert gestion du poste clients - Gayssot Recouvrement"
    }
  },
  {
    path: "/a-propos-de-nous",
    name: "Page1",
    component: Page1,
    meta:{
      title: "Agence experte en gestion du poste clients | Gayssot Recouvrement"
    }
  },
  {
    path: "/nos-services",
    name: "Page2",
    component: Page2,
    meta:{
      title: "Services recouvrement | Gayssot Recouvrement à Lyon"
    }
  },
  {
    path: "/pré-relance-commerciale",
    name: "Page21",
    component: Page21,
    meta:{
      title: "Accueil | Gayssot Recouvrement votre expert gestion du poste clients - Gayssot Recouvrement"
    }
  },
  {
    path: "/recouvrement-amiable",
    name: "Page22",
    component: Page22,
    meta:{
      title: "Recouvrement amiable de factures impayées | Gayssot Recouvrement"
    }
  },
  {
    path: "/recouvrement-judiciaire",
    name: "Page23",
    component: Page23,
    meta:{
      title: "          Recouvrement judiciaire de créances nationales | Gayssot Recouvrement - Gayssot Recouvrement"
    }
  },
  {
    path: "/médiation",
    name: "Page24",
    component: Page24,
    meta:{
      title: "Recouvrement amiable de factures impayées | Gayssot Recouvrement - Gayssot Recouvrement"
    }
  },
  {
    path: "/gestion-des-défaillances",
    name: "Page25",
    component: Page25,
    meta:{
      title: "Gestion des défaillances d’entreprise | Gayssot Recouvrement à Lyon "
    }
  },
  {
    path: "/audit-conseils",
    name: "Page26",
    component: Page26,
    meta:{
      title: "Services Gestion et performance du Poste Clients | Gayssot Recouvrement"
    }
  },
  {
    path: "/créances-à-l'international",
    name: "Page27",
    component: Page27,
    meta:{
      title: "Recouvrement à l'international | Gayssot Recouvrement à Lyon"
    }
  },
  {
    path: "/Formation",
    name: "Page28",
    component: Page28,
    meta:{
      title: "Formation gestion et optimisation du poste client - Gayssot Recouvrement à Lyon"
    }
  },
  {
    path: "/offres-d’emploi",
    name: "Page7",
    component: Page7,
    meta:{
      title: "Rejoignez l'équipe Gayssot - Gayssot Recouvrement"
    }
  },
  {
    path: "/rse",
    name: "Page4",
    component: Page4,
    meta:{
      title: "Responsabilité sociale de l'entreprise - Gayssot Recouvrement"
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
